import { useEffect, useRef, useState, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function useAlertWebSocket() {
  const ws = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const [stats, setStats] = useState({ open_alerts: 0, critical: 0 });
  const [lastEvent, setLastEvent] = useState(null);
  const reconnectTimer = useRef(null);

  const connect = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const wsUrl = BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');
    const wsEndpoint = `${wsUrl}/api/ws/alerts?token=${token}`;

    try {
      ws.current = new WebSocket(wsEndpoint);

      ws.current.onopen = () => {
        setIsConnected(true);
        if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      };

      ws.current.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'stats') {
            setStats({ open_alerts: data.open_alerts, critical: data.critical });
          } else if (data.type !== 'heartbeat') {
            setLastEvent(data);
          }
        } catch (e) {}
      };

      ws.current.onclose = () => {
        setIsConnected(false);
        // Reconnect after 5 seconds
        reconnectTimer.current = setTimeout(connect, 5000);
      };

      ws.current.onerror = () => {
        ws.current?.close();
      };
    } catch (e) {
      setIsConnected(false);
    }
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      ws.current?.close();
    };
  }, [connect]);

  return { isConnected, stats, lastEvent };
}
